class providecnicConfirm {
  constructor(msg) {
    const text = msg.inputtext;
    const insType = sessionStorage.getItem("insuranceType");
    let sendTo = "";
    if (insType === "comprehensive" || insType === "thirdparty") {
      sendTo = "comprehensiveinfo";
    } else if (insType === "thirdpartytheft") {
      sendTo = "allowcamera";
    }
    this.items = {
      id: 30001,
      name: "Custom Vehicle Make",
      type: "text",
      slideimg: "/doctorassistant/dia.jpg",
      options: [
        {
          id: 40012,
          text: "Confirm",
          name: "Confirm",
          price: "",
          type: sendTo,
          desc: "Confirm",
          inputtype: "button",
          key: "cnic_number",
          value: text,
        },
        {
          id: 40013,
          text: "Change",
          name: "Change",
          price: "",
          type: "providecnic",
          desc: "Change Value",
          inputtype: "button",
        },
      ],
      backtostart: false,
      text: [`<p>Provided CNIC is ${text}. Is this correct?</p> `],
    };
  }

  getAllItems() {
    console.log(sessionStorage.getItem("car_information"));
    return this.items;
  }
}

export default providecnicConfirm;
